import colors, { darkThemeColors } from '@theme/colors';

// True Dark surfaces, darkest to lightest. Each takes the place of a LIO light-theme surface, so components that
// use the same token in both themes keep the same layering: page behind cards, wells inside cards, raised on top.
const surface = {
  page: colors.NAVY, // LIO page gradient
  inset: '#28384B', // LIO light gray: dialog bodies and wells inside a card
  card: '#364456', // LIO white: panels, cards, dialogs, tables, the selected tab
  raised: '#44546A', // sits on a card: pills, hover
};

export const darkPalette = {
  background: {
    main: surface.inset,
    paper: surface.card,
    secondary: colors.SUN_YELLOW_SUPPLEMENTAL,
    primary: colors.NAVY,
    light: surface.card,

    // used all over in lio so we need it - other themes would probably not be a gradient
    gradient: surface.page,
  },
  panel: {
    base: surface.card,
    light: surface.card,
    // inner panels on a card; 10% white makes the subdued text on them fail contrast
    main: 'rgba(255, 255, 255, 0.06)',
    dark: colors.BLACK_10,
  },
  drawerNavigation: {
    main: surface.card,
    light: surface.inset,
    alt: colors.NAVY,
  },
  // MUI's grey scale is light in every mode; components use the low end for subtle backgrounds on white
  grey: {
    50: surface.inset,
    100: surface.raised,
    200: surface.raised,
    // pill outlines and placeholder avatars; MUI's default #e0e0e0 glows on dark surfaces
    300: '#5A6A80',
  },
  secondary: {
    light: colors.SUN_YELLOW,
    main: colors.SUN_YELLOW_SUPPLEMENTAL,
    dark: colors.DARK_SEAFOAM,
    alt: colors.SKY_BLUE,
  },
  actions: {
    icon: colors.NAVY,
  },
  text: {
    main: colors.WHITE_100,

    disabled: colors.WHITE_60,
    // 60% white drops under 4.5:1 on inner panels
    subdued: 'rgba(255, 255, 255, 0.7)',

    secondary: colors.WHITE_80,
    caption: colors.WHITE_80,

    placeholder: colors.WHITE_30,
  },
  button: {
    tertiary: colors.SUN_YELLOW_SUPPLEMENTAL,
    tertiaryDark: colors.SEAFOAM_SUPPLEMENTAL,
    outlinedDark: colors.WHITE_100,
    outlined: colors.NAVY,
    containedDisabledText: colors.WHITE_60,
  },
  other: {
    success: colors.DARK_SUCCESS,
    error: colors.DARK_ERROR,
    divider: colors.WHITE_30,
    highlight: colors.SEAFOAM,
    bindIncomplete: colors.DARK_BIND_INCOMPLETE,
  },

  info: {
    main: colors.LIGHT_SKY_BLUE,
    dark: colors.SKY_BLUE,
    hover: colors.WHITE_20,
    hint: colors.WHITE_80,
  },
  // components use .dark as strong text on a light tint; MUI's auto-darkened shades disappear on dark surfaces
  success: {
    main: colors.DARK_SUCCESS,
    light: colors.DARK_SUCCESS,
    dark: colors.DARK_SUCCESS,
    default: colors.DARK_SUCCESS,
  },
  error: {
    light: colors.DARK_ERROR,
    main: colors.DARK_ERROR,
    dark: colors.DARK_ERROR,
    default: colors.DARK_ERROR,
  },
  warning: {
    main: colors.SUN_YELLOW,
    dark: colors.SUN_YELLOW,
  },
  primary: {
    // this is bad use of colors but needed for ow
    main: colors.NAVY,
    dark: darkThemeColors.TOOLTIP_BACKGROUND,
    light: colors.FADED_NAVY_HOVER,
  },
  icon: {
    dark: colors.WHITE_100,
    disabled: colors.WHITE_20,
  },
  accent: {
    secondary: colors.CORAL,
    tertiary: colors.SUN_YELLOW_SUPPLEMENTAL,
  },
  border: {
    // without default/dark, `borderColor: 'border.default'` falls back to the text color (a white line)
    default: colors.WHITE_15,
    light: colors.WHITE_10,
    main: colors.BLACK_25,
    dark: colors.WHITE_30,
  },
  dataGrid: {
    background: surface.card,
    borderLeft: colors.SEAFOAM,
    columnHeaderSorted: colors.SUN_YELLOW_SUPPLEMENTAL,
  },
};
